import { Skeleton } from '@reveni-io/reveni-ui'

import { skeletonSizes } from './constants'
import * as Styles from './styles'

const VisibilityCriterionDetailSkeleton = () => {
  return (
    <Styles.MainContainer>
      <Styles.SectionContainer>
        <Skeleton variant="rounded" width={skeletonSizes.input.width} height={skeletonSizes.input.height} />
        <Skeleton variant="rounded" width={skeletonSizes.textArea.width} height={skeletonSizes.textArea.height} />
      </Styles.SectionContainer>
      <Styles.SectionContainer>
        <Skeleton variant="text" width={skeletonSizes.title.width} height={skeletonSizes.title.height} />
        <Skeleton variant="rounded" width={skeletonSizes.input.width} height={skeletonSizes.input.height} />
      </Styles.SectionContainer>
    </Styles.MainContainer>
  )
}

export default VisibilityCriterionDetailSkeleton
